
import React from "react";
import TestimonialCard from "@/components/TestimonialCard";
import { Info } from "lucide-react";

const ConsultingTestimonials = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Erfahrungsberichte
          </span>
          <h2 className="animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Was Führungskräfte über meine Arbeit sagen
          </h2>
          <p className="text-joerg-600 text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Authentische Einblicke in die Ergebnisse meiner Zusammenarbeit mit Führungskräften und 
            Unternehmern aus unterschiedlichen Branchen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          {/* Male executive testimonial */}
          <TestimonialCard
            content="Jörgs Ansatz der Katalysator-Führung hat unsere Managementkultur grundlegend transformiert. Seine Fähigkeit, komplexe zwischenmenschliche Dynamiken zu erkennen und konstruktiv anzusprechen, hat uns geholfen, Konflikte frühzeitig zu lösen und eine offenere Kommunikation zu etablieren. Die Investition hat sich durch messbar gesteigerte Mitarbeiterzufriedenheit und verbesserte Geschäftsergebnisse mehr als ausgezahlt."
            author="Thomas M."
            role="Geschäftsführer, Mittelständisches Technologieunternehmen"
            delay={0}
          />
          
          {/* Female executive testimonial */}
          <TestimonialCard
            content="Als Gründerin war ich anfangs skeptisch gegenüber externem Consulting. Jörg hat mich jedoch mit seiner authentischen Art und seinem tiefen Verständnis für menschliche Dynamiken überzeugt. Seine Begleitung half mir, meine Führungsrolle neu zu definieren und ein nachhaltiges Wachstum für mein Unternehmen zu gestalten, ohne dabei meine persönlichen Werte zu kompromittieren. Eine wertvolle Investition in die Zukunft meines Unternehmens."
            author="Sandra K."
            role="Gründerin & Geschäftsführerin, Nachhaltiges Startup"
            delay={150}
          />
        </div>

        <div className="mt-8 text-sm text-joerg-500 flex items-center">
          <Info className="h-4 w-4 mr-2 text-joerg-400 flex-shrink-0" />
          <span>Aus Datenschutzgründen wurden die Namen der Kunden und Unternehmensbezeichnungen pseudonymisiert. Die beruflichen Positionen entsprechen den tatsächlichen Tätigkeitsfeldern.</span>
        </div>
      </div>
    </section>
  );
};

export default ConsultingTestimonials;
